class CopyToClipboard {
  constructor(wrapper, button, codeElement) {
    this.wrapper = jQuery(wrapper);
    this.button = jQuery(button);
    this.codeElement = jQuery(codeElement);
    this.texts = {
      buttonText: this.wrapper.data('button-text'),
      successMessage: this.wrapper.data('success-message'),
      errorMessage: this.wrapper.data('error-message'),
    };
    this.timeout = null;

    // event binding
    jQuery(this.button).on('click', this.handleClick.bind(this));
    jQuery(this.codeElement).on('click', this.handleClick.bind(this));

    // after init
    jQuery(this.button).prop('disabled', false).html(this.texts.buttonText);
  }

  handleClick(e) {
    e.preventDefault();
    if (this.timeout != null) {
      return;
    }
    navigator.clipboard.writeText(this.codeElement.text()).then(
      () => this.onSuccess(),
      () => this.onError(error)
    );
  }

  onSuccess() {
    this.button.html(this.texts.successMessage);
    this.setTimeout();
  }

  onError(error) {
    this.button.html(this.texts.errorMessage);
    console.error(error);
  }

  setTimeout() {
    clearTimeout(this.timeout);
    this.timeout = null;
    this.timeout = setTimeout(() => {
      this.resetMessage();
    }, 2000);
  }

  resetMessage() {
    this.button.html(this.texts.buttonText);
    this.timeout = null;
  }
}
